var _rect, _rect2, _rect3, _g, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path, _rect11, _g2, _circle, _circle2, _path2;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgPhoneError = function SvgPhoneError(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 72,
    viewBox: "0 0 47 72",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 72,
    x: 0.002,
    fill: "#B1CFE7",
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 68,
    x: 2.001,
    y: 2,
    fill: "#EFF5FA",
    rx: 6
  })), /*#__PURE__*/React.createElement("mask", {
    id: "phone-error_svg__a",
    width: 41,
    height: 72,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 72,
    fill: "#92BCDD",
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#phone-error_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.53,
    cy: 20.085,
    r: 10.983,
    fill: "#92BCDD"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 4.001,
    y: 20,
    fill: "#fff",
    rx: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    x: 7.001,
    y: 26,
    fill: "#D0E2F1",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 5,
    x: 7.001,
    y: 43,
    fill: "#132B3E",
    rx: 2.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 6,
    x: 7.001,
    y: 33,
    fill: "#F5F5F5",
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 6,
    x: 14.001,
    y: 33,
    fill: "#F5F5F5",
    rx: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 6,
    x: 21.001,
    y: 33,
    fill: "#F5F5F5",
    rx: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 6,
    x: 28.001,
    y: 33,
    fill: "#F5F5F5",
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B1CFE7",
    d: "M10.474 1.83h17.39a2.44 2.44 0 0 1-2.44 2.441h-12.51a2.44 2.44 0 0 1-2.44-2.44Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "phone-error_svg__b",
    width: 37,
    height: 70,
    x: 2,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 70,
    x: 2.001,
    fill: "#B1CFE7",
    rx: 6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#phone-error_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.272,
    cy: 20.085,
    r: 10.983,
    fill: "#D0E2F1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.016,
    cy: 2.441,
    r: 0.61,
    fill: "#5495CA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.017,
    cy: 19.17,
    r: 10.983,
    fill: "#FE5348"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m37.103 14.593-.169 6.215h-1.586l-.173-6.215h1.928Zm-.962 8.988c-.286 0-.531-.101-.736-.303a.99.99 0 0 1-.304-.737.971.971 0 0 1 .304-.728c.205-.202.45-.303.736-.303.275 0 .516.1.724.303a.994.994 0 0 1 .165 1.252 1.121 1.121 0 0 1-.377.377.985.985 0 0 1-.512.14Z"
  })));
};

export { SvgPhoneError as ReactComponent };
export default "/_next/static/media/phone-error.c7ba04bf.svg";